module.exports = __webpack_public_path__ + "static/avatar-0f71fc124030d2833cf0412faab89f01.png";